import { render, staticRenderFns } from "./AllowPushNotificationSetting.vue?vue&type=template&id=62fa79f2&scoped=true&"
import script from "./AllowPushNotificationSetting.vue?vue&type=script&lang=js&"
export * from "./AllowPushNotificationSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa79f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VDialog,VSwitch})
